// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2mbEX","title":"BackImages_title__2oKVw","images":"BackImages_images__3TWXb"};